import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import fr from "@/i18n/fr";
import en from "@/i18n/en";

const DICTS = { fr, en };

const LangCtx = createContext({ lang: "fr", t: (k) => k, prefix: "" });

export const useLang = () => useContext(LangCtx);

export function LangProvider({ children }) {
    const location = useLocation();
    const active = location.pathname === "/en" || location.pathname.startsWith("/en/") ? "en" : "fr";
    const dict = DICTS[active];

    useEffect(() => {
        document.documentElement.lang = active;
    }, [active]);

    const t = (key) => {
        const lookup = (k) => k.split(".").reduce((o, p) => (o != null ? o[p] : undefined), dict);
        let val = lookup(key);
        if (val === undefined && key.startsWith("home.")) val = lookup(key.slice(5));
        return val === undefined ? key : val;
    };
    const prefix = active === "en" ? "/en" : "";

    return <LangCtx.Provider value={{ lang: active, t, prefix }}>{children}</LangCtx.Provider>;
}
